import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function TabMenu(props) {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ padding: '5px 0px' }}>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        sx={{
          color: "#000!important",
          fontSize: "15px!important",
          fontFamily: "AvenirNext!important",
          fontWeight: "600!important",
          '& .MuiButton-endIcon': {
            marginTop: '-5px'
          }
        }}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {location.pathname === `/agent_roster` ? "Agent Roster" : location.pathname === `/users` ? "Users" : "Teams"}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem 
          selected={location.pathname === `/agent_roster`}
          value={`/agent_roster`}
          to={`/agent_roster`}
          component={Link}
          sx={{
            color: "#000!important",
            fontSize: "15px!important",
            fontFamily: "AvenirNext!important",
            fontWeight: "500!important",
          }}
          onClick={(e) => { 
            handleClose();                          
          }} disableRipple>
          Agent Roster
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/users`}
          value={`/users`}
          to={`/users`}
          component={Link}
          sx={{
            color: "#000!important",
            fontSize: "15px!important",
            fontFamily: "AvenirNext!important",
            fontWeight: "500!important",
          }}
          onClick={(e) => { 
            handleClose();                          
          }} disableRipple>
          Users
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/teams`}
          value={`/teams`}
          to={`/teams`}
          component={Link}
          sx={{
            color: "#000!important",
            fontSize: "15px!important",
            fontFamily: "AvenirNext!important",
            fontWeight: "500!important",
          }}
          onClick={(e) => { 
            handleClose();                          
          }} disableRipple>
          Teams
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/events_and_alerts`}
          value={`/events_and_alerts`}
          to={`/events_and_alerts`}
          component={Link}
          sx={{
            color: "#000!important",
            fontSize: "15px!important",
            fontFamily: "AvenirNext!important",
            fontWeight: "500!important",
          }}
          onClick={(e) => { 
            handleClose();                          
          }} disableRipple>
          Events
        </MenuItem>

        <MenuItem 
          selected={location.pathname === `/events_and_alerts`}
          value={`/events_and_alerts`}
          to={`/events_and_alerts`}
          component={Link}
          sx={{
            color: "#000!important",
            fontSize: "15px!important",
            fontFamily: "AvenirNext!important",
            fontWeight: "500!important",
          }}
          onClick={(e) => { 
            handleClose();                          
          }} disableRipple>
          Alerts
        </MenuItem>

      </StyledMenu>
    </div>
  );
}